



































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreateSecondHandOrder from "./create-secondhand.vue";
import EditSecondHandOrder from "./edit-secondhand.vue";
import Ajax from "../../lib/ajax";
class PageSecondHandOrderRequest extends PageRequest {
  title: string;
  publishName: string;
  phoneNumber: string;
  isPublish:boolean | string;
  isSold:boolean |string;
}

@Component({
  components: { CreateSecondHandOrder, EditSecondHandOrder },
})
export default class SecondHandOrders extends AbpBase {
  // 编辑按钮事件处理
  edit() {
    this.editModalShow = true;
  }
  //请求过滤参数
  pagerequest: PageSecondHandOrderRequest = new PageSecondHandOrderRequest();

  createModalShow: boolean = false;
  editModalShow: boolean = false;
  statusList:Array<object>=[{
    label:'待审核',
    value:"false"
  },{
    label:'审核通过',
    value:'true'
  },{
    label:'全部',
    value:''
  }];
  soldList:Array<object>=[{
    label:'未售出',
    value:'false'
  },{
    label:'全部',
    value:''
  },{
    label:'已售出',
    value:'true'
  }]

  get list() {
    return this.$store.state.secondHandOrder.list;
  }
  get loading() {
    return this.$store.state.secondHandOrder.loading;
  }
  create() {
    this.createModalShow = true;
  }

  pageChange(page: number) {
    this.$store.commit("secondHandOrder/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("secondHandOrder/setPageSize", pagesize);
    this.getpage();
  }
  search() {
    this.$store.commit("secondHandOrder/setCurrentPage", 1);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    //filters

    await this.$store.dispatch({
      type: "secondHandOrder/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.secondHandOrder.pageSize;
  }
  get totalCount() {
    return this.$store.state.secondHandOrder.totalCount;
  }
  get currentPage() {
    return this.$store.state.secondHandOrder.currentPage;
  }
  menuClick(name, row) {
    switch (name) {
      case "edit":
        this.$store.commit("secondHandOrder/edit", row);
        this.edit();
        break;
      case "delete":
        this.$Modal.confirm({
          title: this.L("Tips"),
          content: this.L("DeleteWarningMessage"),
          okText: this.L("Yes"),
          cancelText: this.L("No"),
          onOk: async () => {
            await this.$store.dispatch({
              type: "secondHandOrder/delete",
              data: row,
            });
            await this.getpage();
          },
        });
        break;
      default:
        break;
    }
  }
  columns = [
    {
      title: this.L("Title"),
      key: "title",
      tooltip: true,
    },
    {
      title: this.L("LinkMan"),
      key: "publishName",
      width: 120,
    },
    {
      title: this.L("PhoneNumber"),
      key: "phoneNumber",
      width: 120,
    },
    {
      title: this.L("Address"),
      key: "address",
      tooltip: true,
    },
    {
      title: '备注',
      key: "description",
      tooltip: true,
    },
    {
      title: this.L("CreationTime"),
      key: "creationTime",
      width: 100,
      render: (h: any, params: any) => {
        return h(
          "span",
          new Date(params.row.creationTime).toLocaleDateString()
        );
      },
    },
    // {
    //   title: this.L("Actions"),
    //   key: "Actions",
    //   width: 80,
    //   align: "center",
    //   slot: "action",
    // },
  ];
  async created() {
    this.getpage();
  }
}
